import MaplibreDraw from "maplibre-gl-draw";

const Base = MaplibreDraw.modes.draw_line_string;

/**
 * Hapus vertex terakhir (logical) + simpan ke redoStack
 * - Boleh turun sampai 1 titik.
 * - Kalau mau turun ke 0 titik → akhiri mode / hapus feature.
 */
function removeLastVertex(state, ctx) {
  if (!state || !state.line) return;

  // kalau saat ini tinggal 1 titik, remove akan bikin 0 → akhiri/hapus
  if (state.currentVertexPosition <= 1) {
    // opsi A: hapus feature & keluar ke simple_select
    ctx.deleteFeature([state.line.id]);
    ctx.changeMode("draw_line_string");
    return;

    // opsi B (alternatif): batalkan penghapusan & tetap di mode
    // return;
  }

  // remove 1 titik terakhir secara logis
  const removeIndex = state.currentVertexPosition - 1; // index logical terakhir
  const ring = state.line.getCoordinates() || [];
  const removed = ring[removeIndex];
  if (removed) state.__redoStack.push(removed);

  state.line.removeCoordinate(`${removeIndex}`);
  state.currentVertexPosition -= 1;
}

/**
 * Redo vertex terakhir yang di-undo
 */
function redoLastVertex(state) {
  if (!state || !state.line) return;
  if (!state.__redoStack.length) return;

  const coord = state.__redoStack.pop();
  if (!coord) return;

  // sisipkan di ujung (setelah titik terakhir yang fix, sebelum “moving point” internal)
  const insertIndex = state.currentVertexPosition;
  state.line.addCoordinate(`${insertIndex}`, coord[0], coord[1]);
  state.currentVertexPosition += 1;
}

const DrawLineStringUndoRedo = {
  ...Base,

  onSetup(...args) {
    const state = Base.onSetup.apply(this, args);
    state.__redoStack = [];
    return state;
  },

  // setiap kali user menambah titik baru, redoStack harus direset
  onClick(state, e) {
    const before = state.currentVertexPosition;
    const res = Base.onClick ? Base.onClick.call(this, state, e) : undefined;
    const after = state.currentVertexPosition;

    if (after > before) {
      state.__redoStack = [];
    }
    return res;
  },

  // tombol Trash → Undo satu titik (tambahan di atas default)
  onTrash(state) {
    removeLastVertex(state, this);
  },

  // Ctrl/Cmd+Z → Undo,  Ctrl/Cmd+Shift+Z → Redo
  onKeyDown(state, e) {
    const key = e.key?.toLowerCase?.();
    const isMeta = e.ctrlKey || e.metaKey;

    if (isMeta && key === "z" && !e.shiftKey) {
      e.preventDefault();
      removeLastVertex(state, this);
      return;
    }
    if (isMeta && key === "z" && e.shiftKey) {
      e.preventDefault();
      redoLastVertex(state);
      return;
    }

    if (Base.onKeyDown) return Base.onKeyDown.call(this, state, e);
  },

  onStop(state) {
    if (state) state.__redoStack = [];
    if (Base.onStop) Base.onStop.call(this, state);
  },
};

export default DrawLineStringUndoRedo;
